import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatNumberAsText'
})
export class FormatNumberAsTextPipe implements PipeTransform {
    transform(num: number | undefined): any {
        if (num) {
            return formatNumber(Number(num), 'en-US', '1.0-0');
        } else if (num === 0) {
            return num;
        }
    }
}
